import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { withNamespaces } from 'react-i18next';
import { inject } from 'mobx-react';
import bgImage from 'assets/img/login/background.jpg';
import logo from 'assets/img/budgetti_logo_dark.svg';

/*  eslint-disable jsx-a11y/href-no-hash */
@withNamespaces()
@inject('store')
class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
        };

        this.handleChange = this.handleChange.bind(this);
        this.login = this.login.bind(this);
    }

    handleChange(e) {
        const name = e.target.name;
        this.setState({[name]: e.target.value});
    }

    login(e) {
        e.preventDefault();

        // TODO: Implement validation

        const { username, password } = this.state;
        if (username && password) {
            this.props.store.auth.doLogin(username, password);
        }
    }

    render() {
        const { t } = this.props;

        return (
            <div className="login-wrapper">
                <div className="pg-pic">
                    <img src={bgImage}
                         data-src={bgImage}
                         data-src-retina={bgImage}
                         alt=""
                         className="lazy"
                    />
                    <div className="bg-caption pull-bottom sm-pull-bottom text-white p-l-20 m-b-20">
                        <h2 className="semi-bold text-white">
                            {t('LOGIN.BIG_TEXT')}
                        </h2>
                        <p className="small">
                            Photo: <a href="https://libreshot.com" target="_blank" rel="noopener noreferrer">libreshot.com</a>
                        </p>
                    </div>
                </div>

                <div className="login-container bg-white">
                    <Scrollbars>
                        <div className="p-l-50 m-l-20 p-r-50 m-r-20 p-t-50 m-t-30 sm-p-l-15 sm-p-r-15 sm-p-t-40">
                            <img src={logo}
                                 alt="Budgetti Logo"
                                 width="100"
                                 height="30"
                            />
                            <p className="p-t-35">{t('LOGIN.PROMPT')}</p>

                            <form id="form-login" className="p-t-15" onSubmit={this.login}>
                                <div className="form-group form-group-default">
                                    <label>{t('LOGIN.LOGIN')}</label>
                                    <div className="controls">
                                        <input type="email"
                                               name="username"
                                               placeholder={t('LOGIN.EMAIL')}
                                               className="form-control"
                                               onChange={this.handleChange}
                                               required
                                        />
                                    </div>
                                </div>
                                <div className="form-group form-group-default">
                                    <label>{t('LOGIN.PASSWORD')}</label>
                                    <div className="controls">
                                        <input type="password"
                                               className="form-control"
                                               name="password"
                                               placeholder={t('LOGIN.CREDENTIALS')}
                                               onChange={this.handleChange}
                                               required
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    {/*<div className="col-md-6 no-padding sm-p-l-10">
                                        <div className="checkbox ">
                                            <input type="checkbox" value="1" id="checkbox1" />
                                            <label htmlFor="checkbox1">Keep Me Signed in</label>
                                        </div>
                                    </div>*/}
                                    <div className="col-md-6 no-padding sm-p-l-10">
                                        <button className="btn btn-primary btn-cons m-t-10" type="submit">
                                            {t('LOGIN.BUTTON')}
                                        </button>
                                    </div>
                                    <div className="col-md-6 d-flex align-items-center justify-content-end">
                                        <a href={`${process.env.PUB_URL}/register`}>{t('LOGIN.REGISTER')}</a>
                                    </div>
                                </div>
                            </form>

                            <div className="pull-bottom sm-pull-bottom">
                                <div className="m-b-30 p-r-80 sm-m-t-20 sm-p-r-15 sm-p-b-20 clearfix">
                                    {/*<div className="col-sm-3 col-md-2 no-padding">
                                        <img alt=""
                                             className="m-t-5"
                                             data-src="temp/img/demo/pages_icon.png"
                                             data-src-retina="temp/img/demo/pages_icon_2x.png"
                                             height="60"
                                             src="temp/img/demo/pages_icon.png"
                                             width="60"
                                        />
                                    </div>*/}
                                    {/*<div className="col-sm-9 no-padding m-t-10">
                                        <p>
                                            <small>
                                                Create an account or login with <a href="#" className="text-info">Facebook</a> or
                                                <a href="#" className="text-info">Google</a>
                                            </small>
                                        </p>
                                    </div>*/}
                                </div>
                            </div>
                        </div>
                    </Scrollbars>
                </div>
            </div>
        );
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/base/public/login/login.js